import {
  allChecks,
  CHECK_DEFINITIONS,
  conditionTreeFromRule,
  UnsupportedConditionTreeError,
} from './headerAnalysisRuleModel';

const conditionChecksForList = (rule: any) => {
  try {
    return allChecks(conditionTreeFromRule(rule)).map((check, index) => ({
      id: `${rule.id}-${index}`,
      name: CHECK_DEFINITIONS[check].protocol,
      type: CHECK_DEFINITIONS[check].type,
    }));
  } catch (error) {
    if (error instanceof UnsupportedConditionTreeError) return [];
    throw error;
  }
};

export const mapPersistedHeaderAnalysisRule = (rule: any, globalZone = false) => {
  // The server supplies ownership for the combined Zone Admin list. Retain the
  // legacy scope fallback for older responses during rollout.
  const fallbackSource = globalZone ? 'Global' : 'Zone';
  const source = rule.source === 'Global' || rule.source === 'Zone'
    ? rule.source
    : rule.source
      ? 'Unknown'
      : fallbackSource;

  return {
    id: rule.id,
    ruleName: rule.name,
    description: rule.description || '',
    emailAuthentication: conditionChecksForList(rule),
    threatScoreContribution: Number(rule.header_rule_score || 0),
    createdDate: rule.created_at,
    lastUpdated: rule.updated_at || rule.created_at,
    source,
    addedBy: source === 'Global'
      ? 'Global'
      : source === 'Zone'
        ? rule.created_by_name || rule.created_by || 'Zone'
        : '—',
    level: String(rule.category || 'Undetermined').toLowerCase(),
    status: rule.enabled ? 'active' : 'inactive',
    type: source === 'Zone' ? 'Custom' : 'Default',
    rawRule: rule,
  };
};

export const isHeaderAnalysisRuleReadOnly = (row: any, globalZone: boolean) =>
  row.source !== (globalZone ? 'Global' : 'Zone');
